import { Button, ButtonTheme } from '@apply/components';
import { CustomPaymentStep } from '../../../../../constants/CustomPaymentStep';

interface PreviousButtonProps {
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
}

export const PreviousButton: React.FC<PreviousButtonProps> = ({ set_paymentStep }) => {
    const updatePaymentStep = (updatedStep: CustomPaymentStep) => {
        window.scrollTo(0, 0);
        set_paymentStep(updatedStep);
    };
    return (
        <>
            <Button
                id='customPaymentBackButton'
                theme={ButtonTheme.LinkBlue}
                type='button'
                handleClick={() => updatePaymentStep(CustomPaymentStep.PaymentInfo)}
            >
                Back
            </Button>
        </>
    );
};
